export default "__VITE_PUBLIC_ASSET__d6d5b126__"